import createReactClass from 'create-react-class';
import React from 'react';
import Constants from '../constants/constants';

import { dispatcher } from '../dispatcher/dispatcher';

const { ActionTypes } = Constants;
//stores
import { compareDetailsStore } from '../stores/compareDetails';
import { compareSubdivisionStore } from '../stores/compareSubdivision';
import { CurrentSchematic } from '../actions/compare/currentSchematic';
import { StageSchematic } from '../actions/compare/stageSchematic';

function getStateFromStores() {
    return {
        compareListLoading: compareDetailsStore.compareListLoading(),
        restrictionLoading: compareDetailsStore.restrictionLoading(),
        restriction: compareDetailsStore.getForm()
    };
}

export const CompareItemDetailsView = createReactClass({
    componentDidMount: function () {
        compareDetailsStore.subscribe(this._onChange);
        compareSubdivisionStore.subscribe(this._onChange);
    },

    componentWillUnmount: function () {
        compareDetailsStore.unsubscribe(this._onChange);
        compareSubdivisionStore.unsubscribe(this._onChange());
    },

    getInitialState: function () {
        return getStateFromStores();
    },

    changeToList: function () {
        dispatcher.dispatch({
            type: ActionTypes.TOGGLE_COMPARE_LISTS
        });

        var rListOpened = compareDetailsStore.getDetailsOpened();

        if (!rListOpened) {
            try {
                CurrentSchematic.resetSchematicNoPrompt();
                CurrentSchematic.centerAndZoom();
                StageSchematic.resetSchematicNoPrompt();
                StageSchematic.centerAndZoom();
                dispatcher.dispatch({
                    type: ActionTypes.RESET_COMPARE_DETAILS
                });
            } catch (e) {
                console.log("There was an exception ", e)
            }
        }
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    render: function () {
        var restDetails;
        var itemId;
        var style = {
            'fontWeight': 'bold',
            'marginLeft': '5px',
            'marginTop': '5px',
            'fontSize': 'x-large'
        };
        var compareRestriction = this.state.restriction;

        if (compareRestriction === undefined || compareRestriction == null) {
            restDetails = (<div style={style}>Loading Item</div>);
        }
        else {
            var tracks = compareRestriction.tracks.map(function (t) {
                return t.name
            });
            if (compareRestriction.status == "restriction") {
                itemId = "Control Number: " + compareRestriction.controlNumber;
            }
            else {
                itemId = "GRIT Id: GR" + compareRestriction.syncId;
            }
            style.fontSize = 'large';

            var split = tracks.toString().split(",");

            var tracksName = "";
            var otherTracks = "";
            var elipse = "";
            if (split.length > 2) {
                otherTracks = split.join(",", 3, split.length);
                elipse = "...",
                    tracksName = split[0] + "," + split[1];

            } else {
                tracksName = tracks.toString();
            }
            restDetails = (
                <div style={style}>
                    <div style={{ float: "left", padding: "0 1cm 0 0" }}>
                        Type: {compareRestriction.type}
                    </div>
                    <div style={{ float: "left", padding: "0 1cm 0 0" }}>
                        {itemId}
                    </div>
                    <div style={{ float: "left", padding: "0 1cm 0 0" }}>
                        From MP: {compareRestriction.workStartMp + compareRestriction.workStartMpSuffix}
                    </div>
                    <div style={{ float: "left", padding: "0 1cm 0 0" }}>
                        To MP: {compareRestriction.workEndMp + compareRestriction.workEndMpSuffix}
                    </div>
                    <div style={{ float: "left", padding: "0 0 0 0" }}>
                        Tracks: {tracksName}

                        <span title={otherTracks}>{elipse}</span>

                    </div>
                    <div style={{ float: "right" }}>
                        <button onClick={() => this.changeToList()}>Item List</button>
                    </div>
                </div>
            );
        }
        return (
            <div id="compareItemDetails" style={{ height: "45px", border: "solid", backgroundColor: "#b0c4de" }}>
                {restDetails}
            </div>
        );
    }
});
